/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { GpsSourcePb_Enum, gpsSourcePb_EnumFromJSON, gpsSourcePb_EnumToJSON } from "../../../../gen/sensors/gps_source";
import { NcpgInfo } from "../../image_waypoint";
import {
  FreeLookMode_Enum,
  freeLookMode_EnumFromJSON,
  freeLookMode_EnumToJSON,
  MotionArgs,
  Waypoint,
} from "../../waypoints";

export const protobufPackage = "skills";

/** DEPRECATED: Use GotoWaypointActionArgs instead */
export interface GotoGpsWaypointActionArgs {
  /**
   * All fields are optional, and any field that is not defined will result in the vehicle
   * maintaining that value.
   * For example, if x & y are defined, but z is not, the vehicle will maintain the same height.
   */
  waypoint: Waypoint | undefined;
  motionArgs:
    | MotionArgs
    | undefined;
  /** If DISABLED, movement commands will not change the camera orientation */
  freeLookMode: FreeLookMode_Enum;
}

/** DEPRECATED: Use GotoWaypointActionArgs instead */
export interface GotoNavWaypointActionArgs {
  /**
   * All fields are optional, and any field that is not defined will result in the vehicle
   * maintaining that value.
   * For example, if x & y are defined, but z is not, the vehicle will maintain the same
   * height in the Nav frame.
   */
  waypoint: Waypoint | undefined;
  motionArgs:
    | MotionArgs
    | undefined;
  /** If DISABLED, movement commands will not change the camera orientation */
  freeLookMode: FreeLookMode_Enum;
}

/** Arguments for moving to a specified waypoint. */
export interface GotoWaypointActionArgs {
  /**
   * Defines the target waypoint. Fields not defined will result in maintaining the current value.
   * For example, if x & y are defined, but z is not, the vehicle will maintain the same. All fields
   * are optional.
   */
  waypoint:
    | Waypoint
    | undefined;
  /** Arguments specifying how the drone should move to the waypoint. */
  motionArgs: MotionArgs | undefined;
  ncpgInfo:
    | NcpgInfo
    | undefined;
  /** Do not clear or add waypoints during execution */
  preserveArScene: boolean;
  /** If DISABLED, movement commands will not change the camera orientation */
  freeLookMode: FreeLookMode_Enum;
  situationalAwarenessArgs: GotoWaypointActionArgs_SituationalAwarenessArgs | undefined;
}

/**
 * Options to configure situational awareness during a GotoWaypoint action. Handled when a
 * GotoWaypoint action starts (or is resumed after being paused).
 * NOTE: It is debatable whether a GotoWaypoint action is the right place to reason about
 * situational awareness logic. However, in the absense of any GotoWaypoint-composite actions
 * (e.g., a single mission action that handles setting camera settings, commanding a GotoWaypoint,
 * triggering a photo, etc.), and with the requirement that these situational awareness actions
 * should be conditioned upon something about the waypoint task, it needs to go here. All this is
 * to say: long term, we will probably want to move any situational awareness logic out of the
 * GotoWaypoint action and into composite actions.
 */
export interface GotoWaypointActionArgs_SituationalAwarenessArgs {
  /** Trigger if first waypoint task time estimate is >= this value */
  minWaypointTaskTime?: number | undefined;
  situationalAwarenessActions: GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions | undefined;
}

export interface GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions {
  /**
   * Command zoom to be 1x if it is > 1 (within some tolerance). This can make for a better user
   * experience during transit.
   */
  zoomOut: boolean;
}

export interface GotoGpsWaypointResultData {
}

export interface GotoNavWaypointResultData {
}

/**
 * NOTE(roy, duncan) all result data gets dumped into an analytics event - re-evaluate that if/when
 * this message becomes very large or contains information that doesn't make sense to put in
 * analytics.
 */
export interface GotoWaypointResultData {
  /** GPS source at the moment of completion */
  gpsSource: GpsSourcePb_Enum;
  /** GPS fix type at the moment of completion */
  gpsFixType: number;
  /**
   * Time since relocalization info events. Infinite values indicate that no relocalization ever
   * happend.
   */
  timeSinceLastNominalLocalization?: number | undefined;
  timeSinceLastNominalVisualRelocalization?:
    | number
    | undefined;
  /** Whether GPS init was ran. */
  ranGpsInit?:
    | boolean
    | undefined;
  /** Whether the situational awareness */
  situationalAwarenessCommandedZoomOut: boolean;
}

export interface GotoGpsWaypointActionStateData {
}

export interface GotoNavWaypointActionStateData {
}

export interface GotoWaypointActionStateData {
  runningGpsInitialization: boolean;
  /** List of intermediate waypoints the vehicle will travel through to reach the target waypoint */
  intermediateWaypoints: Waypoint[];
  /** Flag that signals if the intermediate waypoints are still being computed */
  intermediateWaypointsDoneComputing: boolean;
}

function createBaseGotoGpsWaypointActionArgs(): GotoGpsWaypointActionArgs {
  return { waypoint: undefined, motionArgs: undefined, freeLookMode: 0 };
}

export const GotoGpsWaypointActionArgs = {
  encode(message: GotoGpsWaypointActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypoint !== undefined) {
      Waypoint.encode(message.waypoint, writer.uint32(10).fork()).ldelim();
    }
    if (message.motionArgs !== undefined) {
      MotionArgs.encode(message.motionArgs, writer.uint32(18).fork()).ldelim();
    }
    if (message.freeLookMode !== 0) {
      writer.uint32(40).int32(message.freeLookMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoGpsWaypointActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoGpsWaypointActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoint = Waypoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.motionArgs = MotionArgs.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.freeLookMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GotoGpsWaypointActionArgs {
    return {
      waypoint: isSet(object.waypoint) ? Waypoint.fromJSON(object.waypoint) : undefined,
      motionArgs: isSet(object.motionArgs) ? MotionArgs.fromJSON(object.motionArgs) : undefined,
      freeLookMode: isSet(object.freeLookMode) ? freeLookMode_EnumFromJSON(object.freeLookMode) : 0,
    };
  },

  toJSON(message: GotoGpsWaypointActionArgs): unknown {
    const obj: any = {};
    if (message.waypoint !== undefined) {
      obj.waypoint = Waypoint.toJSON(message.waypoint);
    }
    if (message.motionArgs !== undefined) {
      obj.motionArgs = MotionArgs.toJSON(message.motionArgs);
    }
    if (message.freeLookMode !== 0) {
      obj.freeLookMode = freeLookMode_EnumToJSON(message.freeLookMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoGpsWaypointActionArgs>, I>>(base?: I): GotoGpsWaypointActionArgs {
    return GotoGpsWaypointActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoGpsWaypointActionArgs>, I>>(object: I): GotoGpsWaypointActionArgs {
    const message = createBaseGotoGpsWaypointActionArgs();
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? Waypoint.fromPartial(object.waypoint)
      : undefined;
    message.motionArgs = (object.motionArgs !== undefined && object.motionArgs !== null)
      ? MotionArgs.fromPartial(object.motionArgs)
      : undefined;
    message.freeLookMode = object.freeLookMode ?? 0;
    return message;
  },
};

function createBaseGotoNavWaypointActionArgs(): GotoNavWaypointActionArgs {
  return { waypoint: undefined, motionArgs: undefined, freeLookMode: 0 };
}

export const GotoNavWaypointActionArgs = {
  encode(message: GotoNavWaypointActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypoint !== undefined) {
      Waypoint.encode(message.waypoint, writer.uint32(10).fork()).ldelim();
    }
    if (message.motionArgs !== undefined) {
      MotionArgs.encode(message.motionArgs, writer.uint32(18).fork()).ldelim();
    }
    if (message.freeLookMode !== 0) {
      writer.uint32(40).int32(message.freeLookMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoNavWaypointActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoNavWaypointActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoint = Waypoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.motionArgs = MotionArgs.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.freeLookMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GotoNavWaypointActionArgs {
    return {
      waypoint: isSet(object.waypoint) ? Waypoint.fromJSON(object.waypoint) : undefined,
      motionArgs: isSet(object.motionArgs) ? MotionArgs.fromJSON(object.motionArgs) : undefined,
      freeLookMode: isSet(object.freeLookMode) ? freeLookMode_EnumFromJSON(object.freeLookMode) : 0,
    };
  },

  toJSON(message: GotoNavWaypointActionArgs): unknown {
    const obj: any = {};
    if (message.waypoint !== undefined) {
      obj.waypoint = Waypoint.toJSON(message.waypoint);
    }
    if (message.motionArgs !== undefined) {
      obj.motionArgs = MotionArgs.toJSON(message.motionArgs);
    }
    if (message.freeLookMode !== 0) {
      obj.freeLookMode = freeLookMode_EnumToJSON(message.freeLookMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoNavWaypointActionArgs>, I>>(base?: I): GotoNavWaypointActionArgs {
    return GotoNavWaypointActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoNavWaypointActionArgs>, I>>(object: I): GotoNavWaypointActionArgs {
    const message = createBaseGotoNavWaypointActionArgs();
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? Waypoint.fromPartial(object.waypoint)
      : undefined;
    message.motionArgs = (object.motionArgs !== undefined && object.motionArgs !== null)
      ? MotionArgs.fromPartial(object.motionArgs)
      : undefined;
    message.freeLookMode = object.freeLookMode ?? 0;
    return message;
  },
};

function createBaseGotoWaypointActionArgs(): GotoWaypointActionArgs {
  return {
    waypoint: undefined,
    motionArgs: undefined,
    ncpgInfo: undefined,
    preserveArScene: false,
    freeLookMode: 0,
    situationalAwarenessArgs: undefined,
  };
}

export const GotoWaypointActionArgs = {
  encode(message: GotoWaypointActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypoint !== undefined) {
      Waypoint.encode(message.waypoint, writer.uint32(10).fork()).ldelim();
    }
    if (message.motionArgs !== undefined) {
      MotionArgs.encode(message.motionArgs, writer.uint32(18).fork()).ldelim();
    }
    if (message.ncpgInfo !== undefined) {
      NcpgInfo.encode(message.ncpgInfo, writer.uint32(26).fork()).ldelim();
    }
    if (message.preserveArScene === true) {
      writer.uint32(32).bool(message.preserveArScene);
    }
    if (message.freeLookMode !== 0) {
      writer.uint32(40).int32(message.freeLookMode);
    }
    if (message.situationalAwarenessArgs !== undefined) {
      GotoWaypointActionArgs_SituationalAwarenessArgs.encode(message.situationalAwarenessArgs, writer.uint32(50).fork())
        .ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoWaypointActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoWaypointActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoint = Waypoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.motionArgs = MotionArgs.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.ncpgInfo = NcpgInfo.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.preserveArScene = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.freeLookMode = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.situationalAwarenessArgs = GotoWaypointActionArgs_SituationalAwarenessArgs.decode(
            reader,
            reader.uint32(),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GotoWaypointActionArgs {
    return {
      waypoint: isSet(object.waypoint) ? Waypoint.fromJSON(object.waypoint) : undefined,
      motionArgs: isSet(object.motionArgs) ? MotionArgs.fromJSON(object.motionArgs) : undefined,
      ncpgInfo: isSet(object.ncpgInfo) ? NcpgInfo.fromJSON(object.ncpgInfo) : undefined,
      preserveArScene: isSet(object.preserveArScene) ? globalThis.Boolean(object.preserveArScene) : false,
      freeLookMode: isSet(object.freeLookMode) ? freeLookMode_EnumFromJSON(object.freeLookMode) : 0,
      situationalAwarenessArgs: isSet(object.situationalAwarenessArgs)
        ? GotoWaypointActionArgs_SituationalAwarenessArgs.fromJSON(object.situationalAwarenessArgs)
        : undefined,
    };
  },

  toJSON(message: GotoWaypointActionArgs): unknown {
    const obj: any = {};
    if (message.waypoint !== undefined) {
      obj.waypoint = Waypoint.toJSON(message.waypoint);
    }
    if (message.motionArgs !== undefined) {
      obj.motionArgs = MotionArgs.toJSON(message.motionArgs);
    }
    if (message.ncpgInfo !== undefined) {
      obj.ncpgInfo = NcpgInfo.toJSON(message.ncpgInfo);
    }
    if (message.preserveArScene === true) {
      obj.preserveArScene = message.preserveArScene;
    }
    if (message.freeLookMode !== 0) {
      obj.freeLookMode = freeLookMode_EnumToJSON(message.freeLookMode);
    }
    if (message.situationalAwarenessArgs !== undefined) {
      obj.situationalAwarenessArgs = GotoWaypointActionArgs_SituationalAwarenessArgs.toJSON(
        message.situationalAwarenessArgs,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoWaypointActionArgs>, I>>(base?: I): GotoWaypointActionArgs {
    return GotoWaypointActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoWaypointActionArgs>, I>>(object: I): GotoWaypointActionArgs {
    const message = createBaseGotoWaypointActionArgs();
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? Waypoint.fromPartial(object.waypoint)
      : undefined;
    message.motionArgs = (object.motionArgs !== undefined && object.motionArgs !== null)
      ? MotionArgs.fromPartial(object.motionArgs)
      : undefined;
    message.ncpgInfo = (object.ncpgInfo !== undefined && object.ncpgInfo !== null)
      ? NcpgInfo.fromPartial(object.ncpgInfo)
      : undefined;
    message.preserveArScene = object.preserveArScene ?? false;
    message.freeLookMode = object.freeLookMode ?? 0;
    message.situationalAwarenessArgs =
      (object.situationalAwarenessArgs !== undefined && object.situationalAwarenessArgs !== null)
        ? GotoWaypointActionArgs_SituationalAwarenessArgs.fromPartial(object.situationalAwarenessArgs)
        : undefined;
    return message;
  },
};

function createBaseGotoWaypointActionArgs_SituationalAwarenessArgs(): GotoWaypointActionArgs_SituationalAwarenessArgs {
  return { minWaypointTaskTime: undefined, situationalAwarenessActions: undefined };
}

export const GotoWaypointActionArgs_SituationalAwarenessArgs = {
  encode(
    message: GotoWaypointActionArgs_SituationalAwarenessArgs,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.minWaypointTaskTime !== undefined) {
      writer.uint32(21).float(message.minWaypointTaskTime);
    }
    if (message.situationalAwarenessActions !== undefined) {
      GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions.encode(
        message.situationalAwarenessActions,
        writer.uint32(10).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoWaypointActionArgs_SituationalAwarenessArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoWaypointActionArgs_SituationalAwarenessArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 21) {
            break;
          }

          message.minWaypointTaskTime = reader.float();
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.situationalAwarenessActions =
            GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GotoWaypointActionArgs_SituationalAwarenessArgs {
    return {
      minWaypointTaskTime: isSet(object.minWaypointTaskTime)
        ? globalThis.Number(object.minWaypointTaskTime)
        : undefined,
      situationalAwarenessActions: isSet(object.situationalAwarenessActions)
        ? GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions.fromJSON(
          object.situationalAwarenessActions,
        )
        : undefined,
    };
  },

  toJSON(message: GotoWaypointActionArgs_SituationalAwarenessArgs): unknown {
    const obj: any = {};
    if (message.minWaypointTaskTime !== undefined) {
      obj.minWaypointTaskTime = message.minWaypointTaskTime;
    }
    if (message.situationalAwarenessActions !== undefined) {
      obj.situationalAwarenessActions = GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions
        .toJSON(message.situationalAwarenessActions);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoWaypointActionArgs_SituationalAwarenessArgs>, I>>(
    base?: I,
  ): GotoWaypointActionArgs_SituationalAwarenessArgs {
    return GotoWaypointActionArgs_SituationalAwarenessArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoWaypointActionArgs_SituationalAwarenessArgs>, I>>(
    object: I,
  ): GotoWaypointActionArgs_SituationalAwarenessArgs {
    const message = createBaseGotoWaypointActionArgs_SituationalAwarenessArgs();
    message.minWaypointTaskTime = object.minWaypointTaskTime ?? undefined;
    message.situationalAwarenessActions =
      (object.situationalAwarenessActions !== undefined && object.situationalAwarenessActions !== null)
        ? GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions.fromPartial(
          object.situationalAwarenessActions,
        )
        : undefined;
    return message;
  },
};

function createBaseGotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions(): GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions {
  return { zoomOut: false };
}

export const GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions = {
  encode(
    message: GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.zoomOut === true) {
      writer.uint32(8).bool(message.zoomOut);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.zoomOut = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions {
    return { zoomOut: isSet(object.zoomOut) ? globalThis.Boolean(object.zoomOut) : false };
  },

  toJSON(message: GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions): unknown {
    const obj: any = {};
    if (message.zoomOut === true) {
      obj.zoomOut = message.zoomOut;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions>, I>>(
    base?: I,
  ): GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions {
    return GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions.fromPartial(base ?? ({} as any));
  },
  fromPartial<
    I extends Exact<DeepPartial<GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions>, I>,
  >(object: I): GotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions {
    const message = createBaseGotoWaypointActionArgs_SituationalAwarenessArgs_SituationalAwarenessActions();
    message.zoomOut = object.zoomOut ?? false;
    return message;
  },
};

function createBaseGotoGpsWaypointResultData(): GotoGpsWaypointResultData {
  return {};
}

export const GotoGpsWaypointResultData = {
  encode(_: GotoGpsWaypointResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoGpsWaypointResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoGpsWaypointResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GotoGpsWaypointResultData {
    return {};
  },

  toJSON(_: GotoGpsWaypointResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoGpsWaypointResultData>, I>>(base?: I): GotoGpsWaypointResultData {
    return GotoGpsWaypointResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoGpsWaypointResultData>, I>>(_: I): GotoGpsWaypointResultData {
    const message = createBaseGotoGpsWaypointResultData();
    return message;
  },
};

function createBaseGotoNavWaypointResultData(): GotoNavWaypointResultData {
  return {};
}

export const GotoNavWaypointResultData = {
  encode(_: GotoNavWaypointResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoNavWaypointResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoNavWaypointResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GotoNavWaypointResultData {
    return {};
  },

  toJSON(_: GotoNavWaypointResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoNavWaypointResultData>, I>>(base?: I): GotoNavWaypointResultData {
    return GotoNavWaypointResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoNavWaypointResultData>, I>>(_: I): GotoNavWaypointResultData {
    const message = createBaseGotoNavWaypointResultData();
    return message;
  },
};

function createBaseGotoWaypointResultData(): GotoWaypointResultData {
  return {
    gpsSource: 0,
    gpsFixType: 0,
    timeSinceLastNominalLocalization: undefined,
    timeSinceLastNominalVisualRelocalization: undefined,
    ranGpsInit: undefined,
    situationalAwarenessCommandedZoomOut: false,
  };
}

export const GotoWaypointResultData = {
  encode(message: GotoWaypointResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.gpsSource !== 0) {
      writer.uint32(8).int32(message.gpsSource);
    }
    if (message.gpsFixType !== 0) {
      writer.uint32(16).int32(message.gpsFixType);
    }
    if (message.timeSinceLastNominalLocalization !== undefined) {
      writer.uint32(29).float(message.timeSinceLastNominalLocalization);
    }
    if (message.timeSinceLastNominalVisualRelocalization !== undefined) {
      writer.uint32(37).float(message.timeSinceLastNominalVisualRelocalization);
    }
    if (message.ranGpsInit !== undefined) {
      writer.uint32(40).bool(message.ranGpsInit);
    }
    if (message.situationalAwarenessCommandedZoomOut === true) {
      writer.uint32(48).bool(message.situationalAwarenessCommandedZoomOut);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoWaypointResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoWaypointResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.gpsSource = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.gpsFixType = reader.int32();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.timeSinceLastNominalLocalization = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.timeSinceLastNominalVisualRelocalization = reader.float();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.ranGpsInit = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.situationalAwarenessCommandedZoomOut = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GotoWaypointResultData {
    return {
      gpsSource: isSet(object.gpsSource) ? gpsSourcePb_EnumFromJSON(object.gpsSource) : 0,
      gpsFixType: isSet(object.gpsFixType) ? globalThis.Number(object.gpsFixType) : 0,
      timeSinceLastNominalLocalization: isSet(object.timeSinceLastNominalLocalization)
        ? globalThis.Number(object.timeSinceLastNominalLocalization)
        : undefined,
      timeSinceLastNominalVisualRelocalization: isSet(object.timeSinceLastNominalVisualRelocalization)
        ? globalThis.Number(object.timeSinceLastNominalVisualRelocalization)
        : undefined,
      ranGpsInit: isSet(object.ranGpsInit) ? globalThis.Boolean(object.ranGpsInit) : undefined,
      situationalAwarenessCommandedZoomOut: isSet(object.situationalAwarenessCommandedZoomOut)
        ? globalThis.Boolean(object.situationalAwarenessCommandedZoomOut)
        : false,
    };
  },

  toJSON(message: GotoWaypointResultData): unknown {
    const obj: any = {};
    if (message.gpsSource !== 0) {
      obj.gpsSource = gpsSourcePb_EnumToJSON(message.gpsSource);
    }
    if (message.gpsFixType !== 0) {
      obj.gpsFixType = Math.round(message.gpsFixType);
    }
    if (message.timeSinceLastNominalLocalization !== undefined) {
      obj.timeSinceLastNominalLocalization = message.timeSinceLastNominalLocalization;
    }
    if (message.timeSinceLastNominalVisualRelocalization !== undefined) {
      obj.timeSinceLastNominalVisualRelocalization = message.timeSinceLastNominalVisualRelocalization;
    }
    if (message.ranGpsInit !== undefined) {
      obj.ranGpsInit = message.ranGpsInit;
    }
    if (message.situationalAwarenessCommandedZoomOut === true) {
      obj.situationalAwarenessCommandedZoomOut = message.situationalAwarenessCommandedZoomOut;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoWaypointResultData>, I>>(base?: I): GotoWaypointResultData {
    return GotoWaypointResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoWaypointResultData>, I>>(object: I): GotoWaypointResultData {
    const message = createBaseGotoWaypointResultData();
    message.gpsSource = object.gpsSource ?? 0;
    message.gpsFixType = object.gpsFixType ?? 0;
    message.timeSinceLastNominalLocalization = object.timeSinceLastNominalLocalization ?? undefined;
    message.timeSinceLastNominalVisualRelocalization = object.timeSinceLastNominalVisualRelocalization ?? undefined;
    message.ranGpsInit = object.ranGpsInit ?? undefined;
    message.situationalAwarenessCommandedZoomOut = object.situationalAwarenessCommandedZoomOut ?? false;
    return message;
  },
};

function createBaseGotoGpsWaypointActionStateData(): GotoGpsWaypointActionStateData {
  return {};
}

export const GotoGpsWaypointActionStateData = {
  encode(_: GotoGpsWaypointActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoGpsWaypointActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoGpsWaypointActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GotoGpsWaypointActionStateData {
    return {};
  },

  toJSON(_: GotoGpsWaypointActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoGpsWaypointActionStateData>, I>>(base?: I): GotoGpsWaypointActionStateData {
    return GotoGpsWaypointActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoGpsWaypointActionStateData>, I>>(_: I): GotoGpsWaypointActionStateData {
    const message = createBaseGotoGpsWaypointActionStateData();
    return message;
  },
};

function createBaseGotoNavWaypointActionStateData(): GotoNavWaypointActionStateData {
  return {};
}

export const GotoNavWaypointActionStateData = {
  encode(_: GotoNavWaypointActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoNavWaypointActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoNavWaypointActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GotoNavWaypointActionStateData {
    return {};
  },

  toJSON(_: GotoNavWaypointActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoNavWaypointActionStateData>, I>>(base?: I): GotoNavWaypointActionStateData {
    return GotoNavWaypointActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoNavWaypointActionStateData>, I>>(_: I): GotoNavWaypointActionStateData {
    const message = createBaseGotoNavWaypointActionStateData();
    return message;
  },
};

function createBaseGotoWaypointActionStateData(): GotoWaypointActionStateData {
  return { runningGpsInitialization: false, intermediateWaypoints: [], intermediateWaypointsDoneComputing: false };
}

export const GotoWaypointActionStateData = {
  encode(message: GotoWaypointActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.runningGpsInitialization === true) {
      writer.uint32(8).bool(message.runningGpsInitialization);
    }
    for (const v of message.intermediateWaypoints) {
      Waypoint.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.intermediateWaypointsDoneComputing === true) {
      writer.uint32(24).bool(message.intermediateWaypointsDoneComputing);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GotoWaypointActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGotoWaypointActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.runningGpsInitialization = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.intermediateWaypoints.push(Waypoint.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.intermediateWaypointsDoneComputing = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GotoWaypointActionStateData {
    return {
      runningGpsInitialization: isSet(object.runningGpsInitialization)
        ? globalThis.Boolean(object.runningGpsInitialization)
        : false,
      intermediateWaypoints: globalThis.Array.isArray(object?.intermediateWaypoints)
        ? object.intermediateWaypoints.map((e: any) => Waypoint.fromJSON(e))
        : [],
      intermediateWaypointsDoneComputing: isSet(object.intermediateWaypointsDoneComputing)
        ? globalThis.Boolean(object.intermediateWaypointsDoneComputing)
        : false,
    };
  },

  toJSON(message: GotoWaypointActionStateData): unknown {
    const obj: any = {};
    if (message.runningGpsInitialization === true) {
      obj.runningGpsInitialization = message.runningGpsInitialization;
    }
    if (message.intermediateWaypoints?.length) {
      obj.intermediateWaypoints = message.intermediateWaypoints.map((e) => Waypoint.toJSON(e));
    }
    if (message.intermediateWaypointsDoneComputing === true) {
      obj.intermediateWaypointsDoneComputing = message.intermediateWaypointsDoneComputing;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GotoWaypointActionStateData>, I>>(base?: I): GotoWaypointActionStateData {
    return GotoWaypointActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GotoWaypointActionStateData>, I>>(object: I): GotoWaypointActionStateData {
    const message = createBaseGotoWaypointActionStateData();
    message.runningGpsInitialization = object.runningGpsInitialization ?? false;
    message.intermediateWaypoints = object.intermediateWaypoints?.map((e) => Waypoint.fromPartial(e)) || [];
    message.intermediateWaypointsDoneComputing = object.intermediateWaypointsDoneComputing ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
